import React, { useState } from 'react'
import './Gifts.css'
import img3 from '../../Assets/custom-site/img_3.png'

const Gifts = ({ colourScheme, giftRegistryMessage = "", gifts = [] }) => {
    const [giftModalOpen, setGiftModalOpen] = useState(false)

    return (
        <>
            <div className={`gifts-container ${colourScheme}-gifts`}>
                <h2 className="gifts-title">Gifts</h2>
                <p className="gifts-message">
                    {giftRegistryMessage || "We're so grateful to celebrate this special moment with the people we love. Your well-wishes and presence mean the world to us, and that's truly the greatest gift."}
                </p>
                {gifts.length > 0 && (
                    <button 
                        className={`gifts-registry-btn ${colourScheme}-gifts-registry-btn`}
                        onClick={() => setGiftModalOpen(true)}
                    >
                        View Gift Registry
                    </button>
                )}

                {/* Mobile bottom image */}
                <div className="gifts-bottom-image">
                    <img src={img3} alt="Gifts" />
                </div>
            </div>

            {/* Gift Registry Modal */}
            {giftModalOpen && (
                <div 
                    id="gift-registry-modal" 
                    className={`gift-registry-modal ${giftModalOpen ? "gift-registry-open" : ""} ${colourScheme}-gift-registry`}
                >
                    <button 
                        onClick={() => setGiftModalOpen(false)} 
                        className="close-gift-registry-btn"
                    >
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </button>

                    <h3 className="gift-registry-title">Gift Registry</h3>

                    <div className="gift-registry-items">
                        {gifts.map((gift, index) => (
                            <div key={index} className="gift-registry-item">
                                <a 
                                    href={gift.url} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="gift-item-link"
                                >
                                    <h4 className="gift-item-name">{gift.name}</h4>
                                    {gift.url && (
                                        <p className="gift-item-url">{gift.url}</p>
                                    )}
                                </a>
                                {gift.bought && (
                                    <span className="gift-bought-badge">Purchased</span>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {/* Overlay */}
            {giftModalOpen && (
                <div 
                    className="gift-registry-overlay" 
                    onClick={() => setGiftModalOpen(false)}
                />
            )}
        </>
    )
}

export default Gifts
